// extracted by mini-css-extract-plugin
export default {"banner":"index_banner_sBl1G","small":"index_small_Mf--b","large":"index_large_4eVu9","car":"index_car_ZX9Ls","url":"index_url_eNIa4"};